import { Button } from "primereact/button";
import React from "react";
import { Dialog } from "primereact/dialog";

const DeleteModal = ({
  deleteProductDialog,
  onHide,
  onConfirm,
  customMessage,
}) => {
  const deleteProductDialogFooter = (
    <>
      <Button label="Yes" icon="pi pi-check" onClick={onConfirm} />
      <Button
        label="No"
        icon="pi pi-times"
        className="p-button-warning"
        onClick={onHide}
      />
    </>
  );

  return (
    <Dialog
      visible={deleteProductDialog}
      style={{ width: "450px" }}
      header="Confirm"
      modal
      footer={deleteProductDialogFooter}
      onHide={onHide}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
        }}
        className="confirmation-content"
      >
        <i
          className="pi pi-exclamation-triangle mr-3"
          style={{ fontSize: "2rem" }}
        />

        <span>{customMessage || "Are you sure you want to delete ?"}</span>
      </div>
    </Dialog>
  );
};

export default DeleteModal;
